<template>
  <div class="mx-auto">
    <v-card flat>
      <v-card-title>Informasi Laporan</v-card-title>
      <v-card-text>
        <v-list class="py-0">
          <v-list-item class="px-0">
            <v-list-item-content class="py-0">
              <v-row no-gutters>
                <v-col cols="12" md="4">
                  <v-label color="caption"><small>Jadwal Laporan</small></v-label>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-calendar-month</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(initValue, 'jadwal') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>Periode Laporan Berlaku</b>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4">
                  <v-label color="caption"><small>Nama Sekolah</small></v-label>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-office-building-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(sekolah, 'sekolah.data.nama') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>NPSN : </b>
                        {{ $getDeepObj(sekolah, 'sekolah.data.npsn') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="12" md="4">
                  <v-label color="caption"><small>Nama Fasilitator</small></v-label>
                  <v-list-item class="px-0">
                    <v-list-item-avatar color="blue" class="mr-2">
                      <v-icon dark>mdi-account</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-0 px-1">
                      <div class="blue--text">
                        {{ $getDeepObj(initValue, 'ptk.nama') || '-' }}
                      </div>
                      <div class="black--text">
                        <b>No. UKG/SIMPKB ID : </b>
                        {{ $getDeepObj(initValue, 'ptk.no_ukg') || $getDeepObj(initValue, 'ptk.ptk_id') || '-' }}
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider class="my-3"></v-divider>
        <div class="blue--text" style="font-size: 17px">Konfirmasi Pengerjaan Laporan PMO</div>
        <div class="black--text font-weight-medium mt-1" style="font-size: 15px">
          Apakah Anda melakukan pendampingan terhadap sekolah pada periode ini ?
        </div>
        <v-radio-group v-model="form.is_terlaksana_pmo" class="mt-2">
          <v-radio value="1" class="mb-3" style="align-items: unset">
            <template v-slot:label>
              <div>
                <div class="orange--text font-weight-medium">Ya</div>
                <div class="black--text">
                  dengan memilih jawaban ini, sistem akan menampilkan laporan yang perlu Anda lengkapi selanjutnya
                </div>
              </div>
            </template>
          </v-radio>
          <v-radio value="0" style="align-items: unset">
            <template v-slot:label>
              <div class="orange--text font-weight-medium">Tidak</div>
              <div class="black--text">
                dengan memilih jawaban ini, sistem tidak akan menampilkan laporan dikarenakan Anda menyatakan tidak
                melakukan pendampingan pada sekolah terkait di periode ini
              </div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    initValue: {
      type: Object,
      default: null,
    },
    sekolah: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});
    },

    getValue() {
      return this.form;
    },
  },
};
</script>
<style scoped>
.v-radio >>> .v-label {
  display: unset;
}
</style>
